import React from 'react';
import { GRID_COL_INDEX_ATTRIBUTE, GridCellProps } from '@progress/kendo-react-grid';
import { ConflictDTO } from '../../store/bid/types';
import { Checkbox } from '../ui';
import { can } from '../../helpers/permissions';

interface Props extends GridCellProps {
  postConflict: (data: ConflictDTO) => void;
}

const EditConflictCell: React.FC<Props> = (props) => {
  const field = props.field || '';
  const value = props.dataItem[field];
  const { bidable_id } = props.dataItem;

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
      }}
      style={props.style}
    >
      <div className="mt-4">
        <Checkbox
          disabled={!can('CAN_EDIT_BID')}
          checked={value}
          onChange={(event) => props.postConflict({ submission_id: bidable_id, conflict: event.target.checked })}
        />
      </div>
    </td>
  );
};

export default EditConflictCell;
